export default __webpack_public_path__ + "static/media/437.3613c531.jpg";